import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section className="bg-white py-12 px-5" data-id="element-84">
      <div className="max-w-xl mx-auto text-center" data-id="element-85">
        <p className="text-sm text-slate-400 mb-6 font-bold uppercase tracking-[0.2em]" data-id="element-86">
          ⏰ El precio de lanzamiento termina en:
        </p>
        <div className="flex items-center justify-center gap-4 mb-6" data-id="element-87">
          <TimeBlock value={formatTime(timeLeft.hours)} label="HRS" data-id="element-88" />
          <span className="text-[#C8A96B] text-3xl font-black mb-6" data-id="element-89">:</span>
          <TimeBlock value={formatTime(timeLeft.minutes)} label="MIN" data-id="element-90" />
          <span className="text-[#C8A96B] text-3xl font-black mb-6" data-id="element-91">:</span>
          <TimeBlock value={formatTime(timeLeft.seconds)} label="SEG" data-id="element-92" />
        </div>
        <p className="text-xs text-slate-400 font-bold uppercase tracking-widest" data-id="element-93">
          Después sube de precio y no vuelve a bajar.
        </p>
      </div>
    </section>;
}
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-94">
      <div className="bg-slate-50 border border-slate-100 rounded-2xl px-6 py-4 min-w-[80px] text-center shadow-sm" data-id="element-95">
        <div className="text-3xl md:text-4xl font-black text-slate-900" data-id="element-96">
          {value}
        </div>
      </div>
      <div className="text-[10px] text-slate-400 font-black uppercase tracking-widest mt-3" data-id="element-97">
        {label}
      </div>
    </div>;
}